module.exports = __webpack_public_path__ + "static/img/底部素材@2x.e9c4533f.png";